import { useState, useEffect } from "react";

const useToast = () => {
    const [toastMessage, setToastMessage] = useState("");

    useEffect(() => {
        if (toastMessage) {
            const timer = setTimeout(() => setToastMessage(""), 5000);
            return () => clearTimeout(timer);
        }
    }, [toastMessage]);

    const showToast = (msg) => setToastMessage(msg);
    const clearToast = () => setToastMessage("");

    return { toastMessage, showToast, clearToast };
};

export default useToast;